import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px',
        paddingBottom: '6px',
    }
}